import { useState } from 'react';
import { CohortType } from '@prisma/client';
import { AcceptedUserInfoUI } from '../accepted-user/AcceptedUserInfoUI';
import {
  ThcStore,
  ThcStoreProvider,
} from '../../../../../src/store/shopEmployee/ThcStore';

type AcceptedParticipant = {
  cohortId: string;
  createdAt: Date;
  cannavigiaCode: string;
  cohortType: CohortType;
  participantId: string;
};

export function AcceptedUserInfo({
  participant,
}: {
  participant: AcceptedParticipant;
}) {
  // Own the store instance for this component's lifetime; a fresh store on
  // every render would re-trigger AcceptedUserInfoUI's dispensary/THC fetch.
  const [thcStore] = useState(() => new ThcStore());

  return (
    <ThcStoreProvider store={thcStore}>
      <AcceptedUserInfoUI {...participant} />
    </ThcStoreProvider>
  );
}
